<template>
  <div class="contain">
    <el-row style="height:3vh;padding-left: 0.5vw;padding-top: 0.1vh;">
      <el-col :span="24">
        <div class="grid-content bg-purple-dark">
          <el-breadcrumb separator-class="el-icon-arrow-right">
            <!-- <el-breadcrumb-item>我的</el-breadcrumb-item> -->
            <el-breadcrumb-item>发起</el-breadcrumb-item>
          </el-breadcrumb>
        </div>
      </el-col>
    </el-row>
    <div class="box">
      <div style="text-align: left;padding: 10px 20px;">检查类型：
        <el-select v-model="checkType" placeholder="请选择">
          <el-option label="质量检查" value="1"></el-option>
          <el-option label="安全检查" value="2"></el-option>
        </el-select>
      </div>
      <p class="p-item">检查内容</p>
      <ul class="ul-item">
        <li>
          <el-input type="textarea" :rows="14" placeholder="请输入内容" v-model="description">
          </el-input>
        </li>
        <li>
          <!-- <el-checkbox :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange">全选</el-checkbox> -->
          <!-- 添加事项计划 -->
          <div style="border-bottom: 1px solid #eee;">
            <div v-for="item in planTree" :key="item.id"
              style="text-align: left;padding:10px;display: flex;align-items: center;justify-content: space-between;font-size: 18px;">
              <div style="display: flex;align-items: center; ">
                <div class="round_red"></div>
                <div style="padding: 10px 0px; font-weight: 600;">{{item.name}}</div>
              </div>
              <div style="display: flex;align-items: center;" @click="addPlan(item)">
                <img style="width: 20px;height:20px;margin-right: 10px;font-size: inherit;" src="../../assets/image/add.png" alt="">添加
              </div>
            </div>
          </div>
          <div>
            <div v-for="item in dataTree" :key="item.id" style="text-align: left;padding:0px 10px;">
              <div style="padding: 10px 0px;font-size: 18px;">{{item.description}}</div>
              <el-checkbox-group v-model="checkedCities" @change="handleChecked" :disabled='isPlan'>
                <el-checkbox v-for="item1 in item.proQsNapes" :label="item1" :key="item1.id">
                  {{item1.description}}
                </el-checkbox>
              </el-checkbox-group>
            </div>
          </div>
          <!-- <el-tree
              :data="dataTree"
              ref="tree"
              show-checkbox
              :props="defaultProps"
              default-expand-all
              :expand-on-click-node="false"
              :highlight-current="true"
              @node-click="handleNodeClick"
              node-key="id"
              :current-node-key="currentNodekey"
              :default-expanded-keys="expandedkeys"
              @check-change="handleChecked">
          </el-tree> -->
        </li>
      </ul>
      <p class="p-item require">添加现场图片：</p>
      <el-upload style="display: flex;padding: 20px 30px;" :action="uploadphotoUrl" list-type="picture-card"
        :on-preview="handlePictureCardPreview" :headers="uploadHead" :data="uploadphotoData"
        :on-success="handleIconSuccess">
        <i class="el-icon-plus"></i>
      </el-upload>
      <div class="ul-item">
        <div>
          <span class="require">选择检查方式：</span>
          <el-select v-model="type" clearable placeholder="请选择">
            <el-option   label="日常巡查" value="1">
            </el-option>
            <el-option label="安全/质量检查" value="2">
            </el-option>
          </el-select>
        </div>
        <div>
          <span class="require">选择责任人：</span>
          <el-select v-model="handleStr" clearable placeholder="请选择">
            <el-option v-for="item in strPerson" :key="item.id" :label="item.name" :value="item.id">
            </el-option>
          </el-select>
        </div>
        <div>
          <span>选择确认人：</span>
          <el-select v-model="apprStr" clearable placeholder="请选择">
            <el-option v-for="item in strPerson" :key="item.id" :label="item.name" :value="item.id">
            </el-option>
          </el-select>
        </div>
        <div class="tip">
          *请选择问题处理结果确认人，不选系统默认检查人为确认人
        </div>
      </div>
      <div class="ul-item" v-if="groupId=='1174625235200061441'">
        <div>
          <span class="require">bim楼栋：</span>
          <el-select v-model="bimId" clearable placeholder="请选择">
            <el-option v-for="item in bimHouse" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
      </div>
      <el-button style="margin:50px auto" @click="submitFun" type="primary">提交</el-button>
    </div>
    <!-- 新增窗口 -->
    <el-dialog title="添加计划" :visible.sync="addFormVisible" center :append-to-body="true" :lock-scroll="false"
      class="add-form" width="400px">
      <div>
        {{checkData.description}}
        <el-checkbox-group v-model="checkedCities1" @change="handleChecked1">
          <el-checkbox v-for="item1 in checkData.proQsNapes" :label="item1" :key="item1.id">
            {{item1.description}}
          </el-checkbox>
        </el-checkbox-group>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="addFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="sumbitAddRow()">确 定</el-button>
      </div>
    </el-dialog>
  </div>

</template>
<script>
  import util from '../../untils/util'
  import myHttp from '../../untils/port'
  import base from '../../untils/base'
  export default {
    data() {
      return {
        checkType: '',
        checkedCities: [],
        checkedCities1: [],
        description: '',
        checkboxItems: [],
        uploadphotoUrl: base.url + '/upload/uploadPhoto', //上传地址
        uploadHead: {
          accessToken: util.session.get('token'),
        },
        uploadphotoData: {
          type: '203',
        },
        fileList: [],
        types: [],
        strPerson: [],
        priority: '',//问题性质
        handleStr: '',//责任人
        apprStr: '',//确认人
        reportBy: '',// 发起人
        picUrls: '',//问题图片
        bimId:'',//对应bim楼栋
        type: '2',
        groupId: '',
        tree: [],
        defaultProps: {
          children: 'proQsNapes',
          label: 'description',
        },
        planTree: [],
        dataTree: [],
        currentNodekey: '', //默认选中的节点树
        expandedkeys: [], //默认展开的节点树
        addFormVisible: false,
        checkData: [],
        planId: '',//计划id
        qsItemId: '',
        isPlan:false,
        //bim楼栋列表
        bimHouse:[
          {id:'1',label:'1栋',value:'1'},{id:'2',label:'2栋',value:'2'},{id:'3',label:'3栋',value:'3'},{id:'4',label:'4栋',value:'4'},
          {id:'5',label:'5栋',value:'5'},{id:'6',label:'6栋',value:'6'},{id:'7',label:'7栋',value:'7'},{id:'8',label:'8栋',value:'8'},
          {id:'9',label:'9栋',value:'9'},{id:'10',label:'10栋',value:'10'},{id:'11',label:'11栋',value:'11'},{id:'12',label:'12栋',value:'12'},
          {id:'13',label:'13栋',value:'13'},
        ],
      }
    },
    mounted() {
      this.groupId = this.$store.state.groupId
      if ('' == this.groupId) {
        this.$store.commit('setGroupId')
        this.groupId = this.$store.state.groupId
      }
      this.getCheckBox()
      this.getDictByType()
      this.getPerson()
      this.getPalnList()
      this.getSaftList()
    },
    methods: {
      getCheckBox() {
        // qsItemInfoList
        var that = this
        myHttp.qsItemInfoList().then(function (resp) {
          if (resp.data.code == '200') {
            that.checkboxItems = resp.data.data.qsItemInfoList || []
          }
        })
      },
      // 改变多选框值
      handleChecked(val) {
        var that = this
        // console.log(this.checkedCities)
        console.log(this.checkedCities1)
        if(this.checkedCities1.length==0){
          this.planId = ''
        }
        that.description = ''
        that.qsItemId = ''
        var arr = []
        val.forEach((item, index) => {
          that.description += index + 1 + '.' + item.description + '    '
          arr.push(item.id)
        });
        that.qsItemId = arr.toString()
        // console.log(arr,that.qsItemId)
      },
      // 
      handleChecked1(val) {
        console.log(val);
        var that = this
        console.log(this.checkedCities1)
        if(this.checkedCities1.length!=0){
          this.isPlan = true
        }else{
          this.isPlan = false
        }
        that.description = ''
        that.qsItemId = ''
        var arr = []
        val.forEach((item, index) => {
          that.description += index + 1 + '.' + item.description + '    '
          arr.push(item.id)
        });
        that.qsItemId = arr.toString()
        // console.log(arr,that.qsItemId)
      },
      handleIconSuccess(res, file, opt, other) {
        if (res.code == '200') {
          console.log(opt)
          console.log(res)
          this.fileList = opt
          // var picUrls =[]
          // for(var i=0;i<opt.length;i++){
          //   picUrls.push(opt[i].response.data.saveUrls)
          // }
          // console.log(picUrls)
        } else {
          this.$message.error(res.msg)
        }
      },
      handlePictureCardPreview(file) {
        this.dialogImageUrl = file.url
        this.dialogVisible = true
      },
      handleRemove(file, fileList) {
        console.log(fileList)
        this.fileList = fileList
      },
      // 获取问题列表
      getDictByType() {
        // getDictByType
        var that = this
        myHttp
          .getDictByType({
            type: 'qs_priority'
          })
          .then(function (resp) {
            if (resp.data.code == '200') {
              that.types = resp.data.data.dictList
            } else {
              that.$message.error(resp.data.msg)
            }
          })
      },
      // 获取责任人列表
      getPerson() {
        var that = this;
        myHttp
          .getRoleUserList({
            groupId: this.groupId,
            userType: util.session.get('roleId')
          })
          .then(function (resp) {
            if (resp.data.code == '200') {
              that.strPerson = resp.data.data.users
            } else {
              that.$message.error(resp.data.msg)
            }
          })
      },
      submitFun() {
        var that = this
        var picUrls = []
        var that = this
        for (var i = 0; i < this.fileList.length; i++) {
          picUrls.push(this.fileList[i].response.data.saveUrls)
        }
        // console.log(picUrls.toString())
        this.picUrls = picUrls.toString()
        var form = {
          form:1,
          projectId: this.groupId,
          type: this.type,
          priority: this.priority, //问题性质
          // happenDate: this.data.date, //发生时间
          description: this.description, //问题描述
          picUrls: this.picUrls, //问题图片
          handleStr: this.handleStr, //责任人id
          apprStr: this.apprStr, //确认人id
          reportBy: util.session.get("user").id, //发起人
          qsItemId: this.qsItemId,
          planId: this.planId,
          bimId:this.bimId,
          checkType: this.checkType
        }
        if (!form.picUrls) {
          this.$message.error('请上传照片')
          return
        }
        if (!form.priority) {
          this.$message.error('请选择问题性质')
          return
        }
        if (!form.handleStr) {
          this.$message.error('请选择责任人')
          return
        }
        // console.log(form)
        myHttp
          .createInfoQs(form)
          .then(function (resp) {
            if (resp.data.code == '200') {
              that.$message.success('提交成功')
              that.$router.go(-1);
            } else {
              that.$message.error(resp.data.msg)
            }
          })
      },
      handleCheckAllChange(val) {
        this.checkedCities = val ? cityOptions : [];
        this.isIndeterminate = false;
      },
      // selectProQsPlanByProject获取计划列表
      getPalnList() {
        var that = this;
        myHttp
          .selectProQsPlanByProject({
            projectId: this.groupId,
            // userType:util.session.get('roleId')
          })
          .then(function (resp) {
            if (resp.data.code == '200') {
              that.planTree = resp.data.data.proQsPlans
              console.log(that.planTree)
            } else {
              that.$message.error(resp.data.msg)
            }
          })
      },
      // 获取 查询安全事项列表
      getSaftList() {
        var that = this;
        myHttp
          .selectProQsNapeTree({
            projectId: this.groupId,
            // userType:util.session.get('roleId')
          })
          .then(function (resp) {
            if (resp.data.code == '200') {
              that.dataTree = resp.data.data.proQsNapes
              // console.log(that.dataTree)
            } else {
              that.$message.error(resp.data.msg)
            }
          })
      },
      handleNodeClick() { },
      addPlan(item) {
        // if(item.id !==this.planId){
       if (this.planId == item.id) {
          // this.planId = item.id
          this.checkData = item.proQsNape
          console.log(item.id)
          this.addFormVisible = true
        }else if(this.qsItemId) {
          this.$message.warning('只能选择一项添加')
          return
        }
        else {
          this.planId = item.id
          this.checkData = item.proQsNape
          console.log(item.id)
          this.addFormVisible = true
        }
      },
      // 计划确定
      sumbitAddRow() {
        this.addFormVisible = false;
        
      }
    },
  }
</script>
<style scoped>
  .contain {
    width: 100%;
    height: 100%;
    padding: 1vh;
  }

  .box {
    width: 100%;
    height: calc(100% - 3vh);
    background: #fff;
    overflow: auto;
  }

  .p-item {
    text-align: left;
    padding: 10px 20px;
  }

  .ul-item {
    display: flex;
    width: 100%;
    justify-content: space-between;
    padding: 10px 20px;
  }

  .ul-item>li {
    width: 46%;
    height: 300px;
    border: 1px dotted #8e9092;
    overflow: auto;
  }

  .contain>>>.el-checkbox-group {
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    height: 90%;
  }

  .contain>>>.el-checkbox-group label {
    text-align: left;
    padding: 0px 20px;
  }

  .tip {
    color: #f00;
  }

  .contain>>>.el-checkbox:last-of-type {
    margin-right: 0;
    text-align: left;
    width: 100%;
    padding: 0px 20px;
  }

  .contain>>>.contain .el-checkbox:last-of-type {

    width: 10% !important;
  }

  .require ::before {
    content: '*' !important;
    color: red  !important;
    font-size: 18px  !important;
  }
  .require{
    width: 180px;
    text-align: right;
    display: inline-block;
  }

  .round_red {
    width: 10px;
    height: 10px;
    border-radius: 50%;
    background-color: #f00;
    margin-right: 10px;
  }

  .el-checkbox-group {
    font-size: 0;
    display: flex;
    justify-content: space-between;
    flex-direction: column;
  }
</style>